<script>
  import BackButton from './BackButton.svelte'
  import ShareIcons from './Share/ShareIcons.svelte'

  export let message
  export let navigateBack
  export let review
  export let shopShareLogo
  export let shopShareUrl
  export let widgetType
  export let shareToText
</script>

<style>
  :global(.success__wrapper-3zFay8) {
    position: absolute;
    width: 430px;
    height: 571px;
    z-index: 99;
    top: -700px;
    background: #fff;
    padding: 15px;
    text-align: center;
    display: flex;
    align-items: center;
    transition: 0.2s;
  }

  .success--active {
    top: 0;
    left: 0;
  }

  :global(.success__content-1lmv7c) {
    display: inline-block;
    margin: auto;
  }

  :global(.success__title-427Nb6) {
    font-size: 18px;
    font-weight: 600;
    margin: 20px 0 10px;
  }

  :global(.share-to-4Y5vAK) {
    display: inline-flex;
    align-items: center;
    margin: auto;
    text-align: center;
  }

  :global(.back-button-3nboHL) {
    z-index: 12345;
    position: absolute;
  }

  :global(.share-to-4Y5vAK img) {
    width: 100%;
    height: 30px;
  }
</style>

<span class="back-button-3nboHL">
  <BackButton {navigateBack} />
</span>

<div id="success-section" class="success__wrapper-3zFay8 success--active">
  <div class="success__content-1lmv7c">
    <div class="">
      <img
        src="https://statisc2test.kudobuzz.com/icons/icon-success.svg"
        alt="checkmark" />
    </div>
    <div class="success__title-427Nb6">{message}</div>
    {#if review}
      <div class="share-to-4Y5vAK">
        <ShareIcons
          isPopup={false}
          {review}
          shopUrl={shopShareUrl}
          accountLogo={shopShareLogo}
          {widgetType}
          {shareToText} />
      </div>
    {/if}
  </div>
</div>
